import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectMilestoneService } from '@shared/components/project/components/project-milestones/project-milestone.service';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ProjectMilestonesComponent } from './components/project-milestones/project-milestones.component';

@NgModule({
  declarations: [],
  exports: [
    ProjectMilestonesComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ToggleSwitchModule,
    ProjectMilestonesComponent
  ],
  providers: [
    ProjectMilestoneService,
  ],
})
export class ProjectMilestonesModule { }
